<h2 class="nomargin">What is your Tax ID?</h2>

<p>Enter your Tax ID with the relevant tax authority for this tax.</p>

<mat-form-field class="fw" id="search-input">
  <input
    matInput
    (keyup.enter)="progress()"
    data-intercom-target="direct-tax-id-input"
    [(ngModel)]="tax.tax_identifier"
    type="text"
    placeholder="Your Tax ID with the relevant tax authority (Optional)"
    autofocus />

  <button
    mat-button
    *ngIf="tax?.tax_identifier"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="tax.tax_identifier = null">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>

<div style="margin-top: 16px" fxLayout fxLayoutGap="24px" fxLayoutAlign="end center">
  <sbnb-button data-intercom-target="direct-tax-id-skip" label="Back" type="secondary" (click)="back()"></sbnb-button>

  <sbnb-button data-intercom-target="direct-tax-id-continue" label="Continue" (click)="progress()"></sbnb-button>
</div>
